/* eslint-disable max-len */

import styled from '@emotion/styled';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import {
  renderBackgroundColor,
  renderSeverity,
  announcementIcons,
} from './announcement.services';

const StyledAnnouncement = styled(Alert)`
  color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 0px;
  background-color: ${({ type }) => renderBackgroundColor(type)};
  padding: ${({ theme }) => theme.spacing(2.5, 4)};
  .MuiAlert-icon {
    padding: 0px;
  }
  .MuiAlert-message {
    padding: 2px 0;
  }
  .MuiAlert-action {
    padding: 0px;
  }
  .MuiIconButton-root:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.common.white};
    outline: ${({ theme }) => theme.palette.primary.dark} solid 2px;
    outline-offset: 4px;
  }
`;

/**
* Renders a <Announcement /> component with optional icon, action.
* @param {Object} props
* @param {Object | undefined} props.iconMapping - the iconMapping maps the severity prop to a range of different icons
* @param {Boolean| node | undefined} props.icon - Set to false to remove the icon or provide icon as node
* @param {string} [props.severity='success'] - defines color and icon used.
* valid values are 'neutral', 'success', 'alert'.
* @param {node | undefined} props.action - renders action at the end of the announcement.
* @param {function | undefined} props.onClose - adds a close icon to the end of the alert and enables an onClose action.
*/

export const Announcement = ({
  iconMapping = {},
  icon = false,
  severity,
  children,
  action = null,
  onClose = null,
  ...other
}) => (
  <StyledAnnouncement
    iconMapping={iconMapping}
    icon={icon && announcementIcons[severity]}
    severity={renderSeverity(severity)}
    type={severity}
    action={action}
    onClose={onClose}
    {...other}
  >
    {children}
  </StyledAnnouncement>
);

Announcement.propTypes = {
  iconMapping: PropTypes.shape({
    [PropTypes.string]: PropTypes.node,
  }),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  severity: PropTypes.oneOf(['neutral', 'success', 'alert']).isRequired,
  children: PropTypes.node.isRequired,
  action: PropTypes.node,
  onClose: PropTypes.func,
};
